// import React, { useState, useEffect } from 'react';
// import { getAllBusesIncome, getBusIncome, getBusIncomeSummary } from '../../Services/Operations/ProductAPI';
// import '../../Styles/ManagementPages.css';
// import { useSelector } from 'react-redux';

// const SkeletonStatsCard = () => (
//   <div className="stat-card skeleton">
//     <div className="skeleton-title"></div>
//     <div className="skeleton-value"></div>
//     <div className="skeleton-subtitle"></div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-actions"></div></td>
//   </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>Bus Number</th>
//           <th>Bus Name</th>
//           <th>Bus Type</th>
//           <th>Owner</th>
//           <th>Bookings</th>
//           <th>Seats Sold</th>
//           <th>Earnings</th>
//           <th>Commission</th>
//           <th>Net Profit</th>
//           <th>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const SkeletonModal = () => (
//   <div className="modal-overlay">
//     <div className="modal-content1 skeleton-modal" style={{ maxWidth: '800px' }}>
//       <div className="modal-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="modal-body">
//         <div className="detail-section">
//           <div className="skeleton-section-title"></div>
//           <div className="detail-grid">
//             {[1, 2, 3, 4].map((i) => (
//               <div key={i} className="skeleton-detail-row">
//                 <div className="skeleton-label"></div>
//                 <div className="skeleton-value"></div>
//               </div>
//             ))}
//           </div>
//         </div>
//         <div className="detail-section">
//           <div className="skeleton-section-title"></div>
//           <div className="financial-cards">
//             {[1, 2, 3, 4, 5, 6].map((i) => (
//               <div key={i} className="financial-card skeleton">
//                 <div className="skeleton-label"></div>
//                 <div className="skeleton-value"></div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//       <div className="modal-footer">
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// const ProfitReport = () => {
//   const [profitData, setProfitData] = useState([]);
//   const [summary, setSummary] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [searching, setSearching] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [viewingBus, setViewingBus] = useState(null);
//   const [error, setError] = useState(null);
//   const { token } = useSelector(state => state.user);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalItems, setTotalItems] = useState(0);
//   const [pageSize] = useState(10);

//   const [filters, setFilters] = useState({
//     startDate: '',
//     endDate: '',
//     busType: '',
//     busCategory: '',
//     ownerId: '',
//     minEarnings: '',
//     maxEarnings: ''
//   });
//   const [showFilters, setShowFilters] = useState(false);
//   const [isFiltered, setIsFiltered] = useState(false);
  
//   const [sortBy, setSortBy] = useState('totalEarnings');
//   const [sortOrder, setSortOrder] = useState('desc');

//   useEffect(() => {
//     const delayDebounceFn = setTimeout(() => {
//       fetchAllBusesProfit();
//     }, 500);

//     return () => clearTimeout(delayDebounceFn);
//   }, [currentPage, searchTerm, filters, sortBy, sortOrder]);

//   const fetchAllBusesProfit = async () => {
//     try {
//       setSearching(true);
//       setLoading(true);
//       setError(null);
      
//       const filterParams = {};
      
//       if (searchTerm) {
//         filterParams.search = searchTerm;
//       }
      
//       Object.keys(filters).forEach(key => {
//         if (filters[key] && filters[key] !== '') {
//           filterParams[key] = filters[key];
//         }
//       });

//       const params = {
//         page: currentPage,
//         limit: pageSize,
//         sortBy: sortBy,
//         sortOrder: sortOrder,
//         ...filterParams
//       };

//       console.log('Fetching profit data with params:', params);

//       const response = await getAllBusesIncome(params, token);
      
//       if (response && response.success) {
//         console.log('Profit data response:', response);
        
//         setProfitData(response.data.buses || []);
//         setSummary(response.data.summary);
//         setTotalPages(response.data.pagination?.totalPages || 1);
//         setTotalItems(response.data.pagination?.totalItems || 0);
        
//         const hasActiveFilters = 
//           searchTerm !== '' || 
//           Object.values(filters).some(value => value && value !== '');
//         setIsFiltered(hasActiveFilters);
//       } else {
//         setError('Failed to fetch profit data.');
//         setProfitData([]);
//       }
//     } catch (err) {
//       console.error('Error fetching profit data:', err);
//       setError('Failed to fetch profit data. Please try again.');
//       setProfitData([]);
//     } finally {
//       setLoading(false);
//       setSearching(false);
//     }
//   };

//   const handleViewBusDetails = async (bus) => {
//     try {
//       setLoading(true);
//       const params = {};
      
//       if (filters.startDate) params.startDate = filters.startDate;
//       if (filters.endDate) params.endDate = filters.endDate;
      
//       const response = await getBusIncome(bus.bus.id, params, token);
      
//       if (response && response.success) {
//         setViewingBus(response.data);
//       } else {
//         alert('Failed to fetch bus details');
//       }
//     } catch (error) {
//       console.error('Error fetching bus details:', error);
//       alert('Error fetching bus details: ' + (error.response?.data?.message || error.message));
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleSearchSubmit = (e) => {
//     e.preventDefault();
//     setCurrentPage(1);
//     fetchAllBusesProfit();
//   };

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const applyFilters = () => {
//     setCurrentPage(1);
//     fetchAllBusesProfit();
//     setShowFilters(false);
//   };

//   const clearFilters = () => {
//     setFilters({
//       startDate: '',
//       endDate: '',
//       busType: '',
//       busCategory: '',
//       ownerId: '',
//       minEarnings: '',
//       maxEarnings: ''
//     });
//     setSearchTerm('');
//     setCurrentPage(1);
//     setIsFiltered(false);
//   };

//   const handleSort = (field) => {
//     if (sortBy === field) {
//       setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
//     } else {
//       setSortBy(field);
//       setSortOrder('desc');
//     }
//     setCurrentPage(1);
//   };

//   const handleExportReport = () => {
//     if (profitData.length === 0) {
//       alert('No data to export');
//       return;
//     }

//     const headers = [
//       'Bus Number', 
//       'Bus Name', 
//       'Bus Type', 
//       'Owner Name', 
//       'Total Bookings', 
//       'Total Seats Sold', 
//       'Total Earnings (₹)', 
//       'Commission (₹)', 
//       'Net Income (₹)',
//       'Avg Ticket Price (₹)'
//     ];
    
//     const csvData = profitData.map(item => [
//       item.bus.busNumber || '',
//       item.bus.busName || '',
//       item.bus.busType || '',
//       item.owner.name || '',
//       item.stats.totalBookings || 0,
//       item.stats.totalSeatsSold || 0,
//       item.stats.totalEarnings || 0,
//       item.stats.totalCommission || 0,
//       item.stats.netIncome || 0,
//       item.stats.averageTicketPrice || 0
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.map(field => `"${field}"`).join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `profit-report-${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);

//     alert('Profit report exported successfully!');
//   };

//   const closeViewModal = () => {
//     setViewingBus(null);
//   };

//   const handleRefresh = () => {
//     setSearchTerm('');
//     setCurrentPage(1);
//     clearFilters();
//     fetchAllBusesProfit();
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const formatCurrency = (amount) => {
//     return `₹${(amount || 0).toLocaleString()}`;
//   };

//   const getBusTypeBadge = (busType) => {
//     const type = (busType || '').toLowerCase();
//     if (type === 'ac') return 'bus-type-ac';
//     if (type === 'non-ac') return 'bus-type-non-ac';
//     return 'bus-type-standard';
//   };

//   const generatePageNumbers = () => {
//     const pages = [];
//     const maxVisiblePages = 5;
    
//     if (totalPages <= maxVisiblePages) {
//       for (let i = 1; i <= totalPages; i++) {
//         pages.push(i);
//       }
//     } else {
//       let start = Math.max(1, currentPage - 2);
//       let end = Math.min(totalPages, start + maxVisiblePages - 1);
      
//       if (end - start + 1 < maxVisiblePages) {
//         start = Math.max(1, end - maxVisiblePages + 1);
//       }
      
//       for (let i = start; i <= end; i++) {
//         pages.push(i);
//       }
//     }
    
//     return pages;
//   };

//   if (loading && profitData.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="page-header">
//           <div className="skeleton-header-title"></div>
//           <div className="header-actions">
//             <div className="skeleton-search"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//           </div>
//         </div>

//         <div className="stats-cards">
//           {[1, 2, 3, 4, 5].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>

//         <SkeletonTable />

//         <div className="pagination-container">
//           <div className="skeleton-pagination-info"></div>
//           <div className="skeleton-pagination-controls"></div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Profit Report</h1>
//         <div className="header-actions">
//           <form onSubmit={handleSearchSubmit} className="search-form">
//             <div style={{ position: 'relative' }}>
//               <input 
//                 type="text" 
//                 placeholder="Search by bus number, name or owner..." 
//                 className="search-input" 
//                 value={searchTerm}
//                 onChange={handleSearchChange}
//                 style={{ width: "70%" }}
//               />
//               {searching && (
//                 <span style={{
//                   position: 'absolute', right: '10px', top: '50%',
//                   transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
//                 }}>
//                   searching...
//                 </span>
//               )}
//             </div>
//           </form>
          
//           <button className="filter-toggle-btn" onClick={() => setShowFilters(!showFilters)}>
//             {showFilters ? 'Hide Filters' : 'Show Filters'}
//           </button>
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="export-btn" onClick={handleExportReport}>
//             Export Report
//           </button>
//         </div>
//       </div>



//       {showFilters && (
//         <div className="profit-filters-panel">
//           <div className="profit-filters-header">
//             <h3>Filter Profit Report</h3>
//             <button className="profit-filters-close" onClick={() => setShowFilters(false)}>
//               ×
//             </button>
//           </div>
//           <div className="profit-filters-grid">
//             <div className="profit-filter-group">
//               <label>Date From</label>
//               <input
//                 type="date"
//                 name="startDate"
//                 value={filters.startDate}
//                 onChange={handleFilterChange}
//                 className="profit-filter-input"
//               />
//             </div>
//             <div className="profit-filter-group">
//               <label>Date To</label>
//               <input
//                 type="date"
//                 name="endDate"
//                 value={filters.endDate}
//                 onChange={handleFilterChange}
//                 className="profit-filter-input"
//               />
//             </div>
//             <div className="profit-filter-group">
//               <label>Bus Type</label>
//               <select
//                 name="busType"
//                 value={filters.busType}
//                 onChange={handleFilterChange}
//                 className="profit-filter-select"
//               >
//                 <option value="">All Types</option>
//                 <option value="AC">AC</option>
//                 <option value="Non-AC">Non-AC</option>
//               </select>
//             </div>
//             <div className="profit-filter-group">
//               <label>Bus Category</label>
//               <select
//                 name="busCategory"
//                 value={filters.busCategory}
//                 onChange={handleFilterChange}
//                 className="profit-filter-select"
//               >
//                 <option value="">All Categories</option>
//                 <option value="sleeper">Sleeper</option>
//                 <option value="seater">Seater</option>
//                 <option value="semi-sleeper">Semi-Sleeper</option>
//               </select>
//             </div>
//             <div className="profit-filter-group">
//               <label>Min Earnings (₦)</label>
//               <input
//                 type="number"
//                 name="minEarnings"
//                 value={filters.minEarnings}
//                 onChange={handleFilterChange}
//                 placeholder="Minimum earnings"
//                 min="0"
//                 className="profit-filter-input"
//               />
//             </div>
//             <div className="profit-filter-group">
//               <label>Max Earnings (₦)</label>
//               <input
//                 type="number"
//                 name="maxEarnings"
//                 value={filters.maxEarnings}
//                 onChange={handleFilterChange}
//                 placeholder="Maximum earnings"
//                 min="0"
//                 className="profit-filter-input"
//               />
//             </div>
//           </div>
//           <div className="profit-filters-actions">
//             <button className="profit-filters-apply" onClick={applyFilters}>
//               Apply Filters
//             </button>
//             <button className="profit-filters-clear" onClick={clearFilters}>
//               Clear All
//             </button>
//           </div>
//           {isFiltered && (
//             <div className="profit-active-filters">
//               <span className="profit-active-label">Active Filters:</span>
//               {searchTerm && (
//                 <span className="profit-filter-tag">
//                   Search: {searchTerm}
//                   <button className="profit-filter-tag-remove" onClick={() => { setSearchTerm(''); fetchAllBusesProfit(); }}>×</button>
//                 </span>
//               )}
//               {filters.busType && (
//                 <span className="profit-filter-tag">
//                   Type: {filters.busType}
//                   <button className="profit-filter-tag-remove" onClick={() => { setFilters(prev => ({ ...prev, busType: '' })); fetchAllBusesProfit(); }}>×</button>
//                 </span>
//               )}
//               {filters.busCategory && (
//                 <span className="profit-filter-tag">
//                   Category: {filters.busCategory}
//                   <button className="profit-filter-tag-remove" onClick={() => { setFilters(prev => ({ ...prev, busCategory: '' })); fetchAllBusesProfit(); }}>×</button>
//                 </span>
//               )}
//               {filters.startDate && (
//                 <span className="profit-filter-tag">
//                   From: {filters.startDate}
//                   <button className="profit-filter-tag-remove" onClick={() => { setFilters(prev => ({ ...prev, startDate: '' })); fetchAllBusesProfit(); }}>×</button>
//                 </span>
//               )}
//               {filters.endDate && (
//                 <span className="profit-filter-tag">
//                   To: {filters.endDate}
//                   <button className="profit-filter-tag-remove" onClick={() => { setFilters(prev => ({ ...prev, endDate: '' })); fetchAllBusesProfit(); }}>×</button>
//                 </span>
//               )}
//               {filters.minEarnings && (
//                 <span className="profit-filter-tag">
//                   Min: ₦{filters.minEarnings}
//                   <button className="profit-filter-tag-remove" onClick={() => { setFilters(prev => ({ ...prev, minEarnings: '' })); fetchAllBusesProfit(); }}>×</button>
//                 </span>
//               )}
//               {filters.maxEarnings && (
//                 <span className="profit-filter-tag">
//                   Max: ₦{filters.maxEarnings}
//                   <button className="profit-filter-tag-remove" onClick={() => { setFilters(prev => ({ ...prev, maxEarnings: '' })); fetchAllBusesProfit(); }}>×</button>
//                 </span>
//               )}
//               <button className="profit-filters-clear-all-tags" onClick={clearFilters}>
//                 Clear All Filters
//               </button>
//             </div>
//           )}
//         </div>
//       )}

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}


//       {summary && (
//         <div className="stats-cards">
//           <div className="stat-card">
//             <h3>Total Earnings</h3>
//             <p>{formatCurrency(summary.totalEarnings)}</p>
//             <span>Gross revenue</span>
//           </div>
//           <div className="stat-card">
//             <h3>Total Commission</h3>
//             <p>{formatCurrency(summary.totalCommission)}</p>
//             <span>Paid to owners</span>
//           </div>
//           <div className="stat-card">
//             <h3>Net Profit</h3>
//             <p>{formatCurrency(summary.totalNetIncome)}</p>
//             <span>After commission</span>
//           </div>
//           <div className="stat-card">
//             <h3>Total Bookings</h3>
//             <p>{summary.totalBookings || 0}</p>
//             <span>Confirmed bookings</span>
//           </div>
//           <div className="stat-card">
//             <h3>Seats Sold</h3>
//             <p>{summary.totalSeatsSold || 0}</p>
//             <span>Total seats</span>
//           </div>
//         </div>
//       )}


//       {loading && profitData.length > 0 && (
//         <div className="loading-overlay">
//           <div className="loading-spinner"></div>
//           <span>Updating data...</span>
//         </div>
//       )}


//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th onClick={() => handleSort('busNumber')} style={{ cursor: 'pointer' }}>
//                 Bus Number {sortBy === 'busNumber' && (sortOrder === 'asc' ? '↑' : '↓')}
//               </th>
//               <th onClick={() => handleSort('busName')} style={{ cursor: 'pointer' }}>
//                 Bus Name {sortBy === 'busName' && (sortOrder === 'asc' ? '↑' : '↓')}
//               </th>
//               <th>Bus Type</th>
//               <th onClick={() => handleSort('ownerName')} style={{ cursor: 'pointer' }}>
//                 Owner {sortBy === 'ownerName' && (sortOrder === 'asc' ? '↑' : '↓')}
//               </th>
//               <th onClick={() => handleSort('totalBookings')} style={{ cursor: 'pointer' }}>
//                 Bookings {sortBy === 'totalBookings' && (sortOrder === 'asc' ? '↑' : '↓')}
//               </th>
//               <th onClick={() => handleSort('totalSeatsSold')} style={{ cursor: 'pointer' }}>
//                 Seats Sold {sortBy === 'totalSeatsSold' && (sortOrder === 'asc' ? '↑' : '↓')}
//               </th>
//               <th onClick={() => handleSort('totalEarnings')} style={{ cursor: 'pointer' }}>
//                 Earnings {sortBy === 'totalEarnings' && (sortOrder === 'asc' ? '↑' : '↓')}
//               </th>
//               <th onClick={() => handleSort('totalCommission')} style={{ cursor: 'pointer' }}>
//                 Commission {sortBy === 'totalCommission' && (sortOrder === 'asc' ? '↑' : '↓')}
//               </th>
//               <th onClick={() => handleSort('netIncome')} style={{ cursor: 'pointer' }}>
//                 Net Profit {sortBy === 'netIncome' && (sortOrder === 'asc' ? '↑' : '↓')}
//               </th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {profitData.length > 0 ? (
//               profitData.map((item, index) => (
//                 <tr key={item.bus.id || index}>
//                   <td className="transaction">{item.bus.busNumber || 'N/A'}</td>
//                   <td>{item.bus.busName || 'N/A'}</td>
//                   <td>
//                     <span className={`bus-type-badge ${getBusTypeBadge(item.bus.busType)}`}>
//                       {item.bus.busType || 'Standard'}
//                     </span>
//                   </td>
//                   <td>
//                     <div>
//                       <div>{item.owner.name || 'N/A'}</div>
//                       <div className="phone">{item.owner.phone || ''}</div>
//                     </div>
//                   </td>
//                   <td>{item.stats.totalBookings || 0}</td>
//                   <td>{item.stats.totalSeatsSold || 0}</td>
//                   <td className="earning">{formatCurrency(item.stats.totalEarnings)}</td>
//                   <td className="commission">{formatCurrency(item.stats.totalCommission)}</td>
//                   <td className="profit">{formatCurrency(item.stats.netIncome)}</td>
//                   <td>
//                     <div className="action-buttons">
//                       <button 
//                         className="action-btn view" 
//                         onClick={() => handleViewBusDetails(item)}
//                         disabled={loading}
//                       >
//                         {loading ? 'Loading...' : 'View Details'}
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="10" className="no-data">
//                   <p>No profit data found {isFiltered ? 'matching your filters' : ''}.</p>
//                   {isFiltered && (
//                     <button className="clear-filters-link" onClick={clearFilters}>
//                       Clear filters to see all data
//                     </button>
//                   )}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>


//       {totalPages > 1 && (
//         <div className="pagination-container">
//           <div className="pagination-info">
//             Showing {profitData.length} of {totalItems} buses
//             (Page {currentPage} of {totalPages})
//             {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
//             {isFiltered && !searchTerm && <span className="filtered-indicator"> • Filtered Results</span>}
//           </div>
//           <div className="pagination-controls">
//             <button 
//               className="pagination-btn" 
//               onClick={handlePrevPage}
//               disabled={currentPage === 1 || loading}
//             >
//               Previous
//             </button>
            
//             <div className="page-numbers">
//               {generatePageNumbers().map(pageNumber => (
//                 <button
//                   key={pageNumber}
//                   className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                   onClick={() => handlePageClick(pageNumber)}
//                   disabled={loading}
//                 >
//                   {pageNumber}
//                 </button>
//               ))}
              
//               {totalPages > 5 && currentPage < totalPages - 2 && (
//                 <>
//                   <span className="page-dots">...</span>
//                   <button
//                     className="page-number"
//                     onClick={() => handlePageClick(totalPages)}
//                     disabled={loading}
//                   >
//                     {totalPages}
//                   </button>
//                 </>
//               )}
//             </div>
            
//             <button 
//               className="pagination-btn" 
//               onClick={handleNextPage}
//               disabled={currentPage === totalPages || loading}
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       )}


//       {viewingBus && !loading && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '800px' }}>
//             <div className="modal-header">
//               <h3>Bus Profit Details - {viewingBus.bus?.busNumber}</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">

//               <div className="detail-section">
//                 <h4>Bus Information</h4>
//                 <div className="detail-grid">
//                   <div className="detail-row">
//                     <label>Bus Number:</label>
//                     <span>{viewingBus.bus?.busNumber || 'N/A'}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Bus Name:</label>
//                     <span>{viewingBus.bus?.busName || 'N/A'}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Bus Type:</label>
//                     <span>{viewingBus.bus?.busType || 'N/A'}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Total Seats:</label>
//                     <span>{viewingBus.bus?.totalSeats || 'N/A'}</span>
//                   </div>
//                 </div>
//               </div>


//               <div className="detail-section">
//                 <h4>Owner Information</h4>
//                 <div className="detail-grid">
//                   <div className="detail-row">
//                     <label>Owner Name:</label>
//                     <span>{viewingBus.owner?.name || 'N/A'}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Company:</label>
//                     <span>{viewingBus.owner?.companyName || 'N/A'}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Email:</label>
//                     <span>{viewingBus.owner?.email || 'N/A'}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Phone:</label>
//                     <span>{viewingBus.owner?.phone || 'N/A'}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Commission Rate:</label>
//                     <span>{viewingBus.owner?.commissionRate || 10}%</span>
//                   </div>
//                 </div>
//               </div>


//               <div className="detail-section">
//                 <h4>Financial Summary</h4>
//                 <div className="financial-cards">
//                   <div className="financial-card">
//                     <label>Total Earnings</label>
//                     <p className="earning">{formatCurrency(viewingBus.summary?.totalEarnings)}</p>
//                   </div>
//                   <div className="financial-card">
//                     <label>Total Commission</label>
//                     <p className="commission">{formatCurrency(viewingBus.summary?.totalCommission)}</p>
//                   </div>
//                   <div className="financial-card">
//                     <label>Net Profit</label>
//                     <p className="profit">{formatCurrency(viewingBus.summary?.netIncome)}</p>
//                   </div>
//                   <div className="financial-card">
//                     <label>Total Bookings</label>
//                     <p>{viewingBus.summary?.totalBookings || 0}</p>
//                   </div>
//                   <div className="financial-card">
//                     <label>Seats Sold</label>
//                     <p>{viewingBus.summary?.totalSeatsSold || 0}</p>
//                   </div>
//                   <div className="financial-card">
//                     <label>Occupancy Rate</label>
//                     <p>{viewingBus.summary?.occupancyRate || 0}%</p>
//                   </div>
//                 </div>
//               </div>


//               {viewingBus.dailyBreakdown && viewingBus.dailyBreakdown.length > 0 && (
//                 <div className="detail-section">
//                   <h4>Daily Breakdown</h4>
//                   <div className="daily-breakdown-table">
//                     <table className="mini-table">
//                       <thead>
//                         <tr>
//                           <th>Date</th>
//                           <th>Earnings</th>
//                           <th>Bookings</th>
//                           <th>Seats Sold</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {viewingBus.dailyBreakdown.map((day, idx) => (
//                           <tr key={idx}>
//                             <td>{day.date}</td>
//                             <td>{formatCurrency(day.earnings)}</td>
//                             <td>{day.bookings}</td>
//                             <td>{day.seatsSold}</td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               )}


//               {viewingBus.bookings && viewingBus.bookings.length > 0 && (
//                 <div className="detail-section">
//                   <h4>Recent Bookings</h4>
//                   <div className="bookings-list">
//                     <table className="mini-table">
//                       <thead>
//                         <tr>
//                           <th>PNR</th>
//                           <th>Date</th>
//                           <th>Seats</th>
//                           <th>Amount</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {viewingBus.bookings.slice(0, 5).map((booking, idx) => (
//                           <tr key={idx}>
//                             <td>{booking.pnr}</td>
//                             <td>{new Date(booking.journeyDate).toLocaleDateString()}</td>
//                             <td>{booking.seatsBooked}</td>
//                             <td>{formatCurrency(booking.amount)}</td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                     {viewingBus.bookings.length > 5 && (
//                       <p style={{ textAlign: 'center', marginTop: '10px', color: '#666' }}>
//                         +{viewingBus.bookings.length - 5} more bookings
//                       </p>
//                     )}
//                   </div>
//                 </div>
//               )}
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}


//       {viewingBus && loading && <SkeletonModal />}
//     </div>
//   );
// };

// export default ProfitReport;

import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import '../../Styles/ManagementPages.css';
import '../../Styles/PrimaryRouteManage.css';   // base "prm-" design
import '../../Styles/PrimaryBusOwner.css';      // shared additions (avatar, pagination…)
import '../../Styles/CustomerReport.css';       // customer-only additions (load LAST)
import { getAllBusesIncome, getBusIncome, getBusIncomeSummary } from '../../Services/Operations/ProductAPI';
import { Icon, BusSvg, StatCard, Field, Avatar, Pagination } from './PrimaryUI';

// ---------- helpers ----------
const pad = (n) => String(n).padStart(2, '0');
const formatDateDMY = (d) => {
  if (!d) return 'N/A';
  const x = new Date(d);
  if (isNaN(x.getTime())) return 'N/A';
  return `${pad(x.getDate())}.${pad(x.getMonth() + 1)}.${x.getFullYear()}`;
};
const formatCurrency = (amount) =>
  new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: 0 })
    .format(amount || 0);
const safeStr = (v) => (v === null || v === undefined ? '' : String(v));
const safeNum = (v) => (v === null || v === undefined ? 0 : Number(v) || 0);

const busTypeTone = (t) => {
  const s = (t || '').toLowerCase();
  if (s === 'ac') return 'active';
  if (s === 'non-ac') return 'inactive';
  return 'pending';
};
const BusTypePill = ({ value }) => (
  <span className={`prm-status ${busTypeTone(value)}`}>{value || 'Standard'}</span>
);

// ============================================================
// Bus card
// ============================================================
const BusCard = ({ item, index, onView, loading }) => (
  <div className="prm-card cr-card" style={{ animationDelay: `${index * 70}ms` }}>
    <div className="prm-card-top">
      <div className="pbo-owner-id">
        <Avatar name={item.bus?.busName || item.bus?.busNumber || 'Bus'} size={52} />
        <div>
          <div className="prm-card-no">
            <Icon name="bus" size={12} /> {safeStr(item.bus?.busNumber) || 'N/A'}
          </div>
          <h3 className="prm-card-title">{safeStr(item.bus?.busName) || 'N/A'}</h3>
          <div className="prm-card-sub">
            <BusTypePill value={item.bus?.busType} />
          </div>
        </div>
      </div>
      <span className="prm-status active">{safeNum(item.stats?.totalBookings)} bkgs</span>
    </div>

    <div className="pbo-contact">
      <div><Icon name="users" size={14} /> {safeStr(item.owner?.name) || 'N/A'}</div>
      <div><Icon name="phone" size={14} /> {safeStr(item.owner?.phone) || 'N/A'}</div>
    </div>

    <div className="prm-metrics">
      <div className="prm-metric">
        <div className="v"><Icon name="wallet" size={15} /> {formatCurrency(item.stats?.totalEarnings)}</div>
        <div className="l">Earnings</div>
      </div>
      <div className="prm-metric">
        <div className="v" style={{ color: '#e53e3e' }}>
          <Icon name="tag" size={15} /> {formatCurrency(item.stats?.totalCommission)}
        </div>
        <div className="l">Commission</div>
      </div>
      <div className="prm-metric">
        <div className="v" style={{ color: '#2f855a' }}>
          <Icon name="check" size={15} /> {formatCurrency(item.stats?.netIncome)}
        </div>
        <div className="l">Net Profit</div>
      </div>
    </div>

    <div className="pbo-card-actions">
      <button className="prm-btn view sm" onClick={() => onView(item)} disabled={loading}>
        <Icon name="eye" size={14} /> {loading ? 'Loading…' : 'View Details'}
      </button>
    </div>
  </div>
);

// ============================================================
// MAIN
// ============================================================
const ProfitReport = () => {
  const { token } = useSelector(state => state.user);

  const [profitData, setProfitData] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [searching, setSearching] = useState(false);
  const [error, setError] = useState(null);

  const [searchTerm, setSearchTerm] = useState('');
  const [layout, setLayout] = useState('table');
  const [showFilters, setShowFilters] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));

  const [filters, setFilters] = useState({
    startDate: '', endDate: '',
    busType: '', busCategory: '', ownerId: '',
    minEarnings: '', maxEarnings: ''
  });

  const [sortBy, setSortBy] = useState('totalEarnings');
  const [sortOrder, setSortOrder] = useState('desc');

  const [viewingBus, setViewingBus] = useState(null);
  const [isFetchingDetails, setIsFetchingDetails] = useState(false);

  // ---------- fetch ----------
  useEffect(() => {
    const t = setTimeout(fetchAllBusesProfit, 400);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize, searchTerm, filters, sortBy, sortOrder]);

  const fetchAllBusesProfit = async () => {
    try {
      setSearching(true);
      setLoading(true);
      setError(null);

      const filterParams = {};
      if (searchTerm) filterParams.search = searchTerm;
      Object.keys(filters).forEach(k => {
        if (filters[k] && filters[k] !== '') filterParams[k] = filters[k];
      });

      const params = {
        page: currentPage, limit: pageSize,
        sortBy, sortOrder,
        ...filterParams
      };

      const response = await getAllBusesIncome(params, token);
      if (response && response.success) {
        setProfitData(response.data.buses || []);
        setSummary(response.data.summary);
        setTotalItems(response.data.pagination?.totalItems || 0);
        const hasActive =
          searchTerm !== '' ||
          Object.values(filters).some(v => v && v !== '');
        setIsFiltered(hasActive);
      } else {
        setError('Failed to fetch profit data.');
        setProfitData([]);
      }
    } catch (err) {
      console.error('Error fetching profit data:', err);
      setError('Failed to fetch profit data. Please try again.');
      setProfitData([]);
    } finally {
      setLoading(false);
      setSearching(false);
      setFirstLoad(false);
    }
  };

  useEffect(() => { if (currentPage > totalPages) setCurrentPage(totalPages); }, [currentPage, totalPages]);

  const handleViewBusDetails = async (bus) => {
    try {
      setIsFetchingDetails(true);
      setViewingBus(bus); // show instant summary
      const params = {};
      if (filters.startDate) params.startDate = filters.startDate;
      if (filters.endDate) params.endDate = filters.endDate;
      const response = await getBusIncome(bus.bus.id, params, token);
      if (response && response.success) {
        setViewingBus(response.data);
      } else {
        toast.error('Failed to fetch bus details');
      }
    } catch (error) {
      console.error('Error fetching bus details:', error);
      toast.error('Error fetching bus details: ' + (error.response?.data?.message || error.message));
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const applyFilters = () => { setCurrentPage(1); fetchAllBusesProfit(); setShowFilters(false); };
  const clearFilters = () => {
    setFilters({ startDate: '', endDate: '', busType: '', busCategory: '', ownerId: '', minEarnings: '', maxEarnings: '' });
    setSearchTerm('');
    setCurrentPage(1);
    setIsFiltered(false);
  };
  const handleRefresh = () => { clearFilters(); fetchAllBusesProfit(); };

  const handleSort = (field) => {
    if (sortBy === field) setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    else { setSortBy(field); setSortOrder('desc'); }
    setCurrentPage(1);
  };

  const handleExportReport = () => {
    if (profitData.length === 0) return toast.warning('No data to export');

    const headers = ['Bus Number', 'Bus Name', 'Bus Type', 'Owner Name', 'Bookings', 'Seats Sold', 'Earnings', 'Commission', 'Net Income', 'Avg Ticket Price'];
    const rows = profitData.map(item => [
      item.bus?.busNumber || '', item.bus?.busName || '', item.bus?.busType || '',
      item.owner?.name || '',
      safeNum(item.stats?.totalBookings), safeNum(item.stats?.totalSeatsSold),
      safeNum(item.stats?.totalEarnings), safeNum(item.stats?.totalCommission),
      safeNum(item.stats?.netIncome), safeNum(item.stats?.averageTicketPrice)
    ]);

    const csv = [headers.join(','), ...rows.map(r => r.map(f => `"${String(f ?? '').replace(/"/g, '""')}"`).join(','))].join('\n');
    const url = window.URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = `profit-report-${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    toast.success('Profit report exported successfully');
  };

  const closeViewModal = () => setViewingBus(null);

  const SortArrow = ({ field }) => sortBy === field ? <span style={{ marginLeft: 4 }}>{sortOrder === 'asc' ? '↑' : '↓'}</span> : null;

  // ============================================================
  if (firstLoad && loading) {
    return (
      <div className="prm-page">
        <div className="prm-hero"><div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="wallet" size={13} /> Profit</span>
          <h1>Profit Report</h1><p>Loading profit data…</p>
        </div></div>
        <div style={{ height: 24 }} />
        <div className="prm-grid">
          {[0, 1, 2].map(i => (
            <div className="prm-skel" key={i}>
              <div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="prm-page">
      {/* HERO */}
      <div className="prm-hero">
        <div className="prm-hero-road" aria-hidden="true">
          <span className="prm-hero-roadbus"><BusSvg size={46} /></span>
        </div>
        <div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="wallet" size={13} /> Revenue & Profit</span>
          <h1>Profit Report</h1>
          <p>Bus-level earnings, commission, and net profit across your fleet — sortable and filterable.</p>
        </div>
        <div className="prm-hero-actions">
          <div className="prm-search">
            <Icon name="search" size={17} />
            <input
              type="text"
              placeholder="Search bus number, name or owner…"
              value={searchTerm}
              onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
            />
            {searchTerm && (
              <button className="prm-search-clear" onClick={() => { setSearchTerm(''); setCurrentPage(1); }}>×</button>
            )}
          </div>
          <button className="pbo-icon-btn" onClick={() => setShowFilters(!showFilters)} title="Filters">
            <Icon name="list" size={17} />
          </button>
          <button className="pbo-icon-btn" onClick={handleRefresh} title="Refresh">
            <Icon name="refresh" size={17} />
          </button>
          <button className="pbo-icon-btn" onClick={handleExportReport} title="Export CSV">
            <Icon name="download" size={17} />
          </button>
        </div>
      </div>

      {error && (
        <div className="cr-error">
          <Icon name="info" size={16} /> {error}
          <button className="prm-btn ghost sm" onClick={fetchAllBusesProfit}>Retry</button>
        </div>
      )}

      {/* STATS */}
      {summary && (
        <div className="prm-stats">
          <StatCard icon="wallet" tone="cyan" label="Total Earnings" value={safeNum(summary.totalEarnings)} hint="Gross revenue" delay={80} />
          <StatCard icon="tag" tone="amber" label="Total Commission" value={safeNum(summary.totalCommission)} hint="Paid to owners" delay={160} />
          <StatCard icon="check" tone="green" label="Net Profit" value={safeNum(summary.totalNetIncome)} hint="After commission" delay={240} />
          <StatCard icon="users" tone="indigo" label="Bookings / Seats" value={safeNum(summary.totalBookings)} hint={`${safeNum(summary.totalSeatsSold)} seats sold`} delay={320} />
        </div>
      )}

      {/* TOOLBAR */}
      <div className="prm-toolbar">
        <div className="prm-toolbar-left">
          <div className="prm-chips">
            <button className="prm-chip active">All Buses <span className="count">{profitData.length}</span></button>
            <button
              className="prm-chip"
              onClick={() => handleSort('totalEarnings')}
              title="Sort by earnings"
            >
              Sort: {sortBy} {sortOrder === 'asc' ? '↑' : '↓'}
            </button>
          </div>
          {searchTerm && <span className="prm-tag amber">Search: “{searchTerm}”</span>}
          {searching && <span className="prm-tag gray">searching…</span>}
        </div>
        <div className="prm-toolbar-right">
          <span className="prm-result-count">Showing <b>{profitData.length}</b> of {totalItems}</span>
          <div className="prm-layout-toggle">
            <button className={layout === 'cards' ? 'active' : ''} onClick={() => setLayout('cards')} title="Card view">
              <Icon name="grid" size={17} />
            </button>
            <button className={layout === 'table' ? 'active' : ''} onClick={() => setLayout('table')} title="Table view">
              <Icon name="list" size={17} />
            </button>
          </div>
        </div>
      </div>

      {/* FILTER PANEL */}
      {showFilters && (
        <div className="prm-form-modal prm-form-modal-sm" style={{ marginBottom: 16 }}>
          <div className="prm-form-head">
            <div className="prm-form-head-row">
              <span className="prm-form-badge"><Icon name="search" size={22} /></span>
              <div><h3>Filter profit report</h3><p>Refine the current result set</p></div>
            </div>
            <button className="prm-modal-close" onClick={() => setShowFilters(false)}>×</button>
          </div>
          <div className="prm-form-body">
            <div className="prm-fgrid">
              <Field label="Date From">
                <input type="date" className="prm-input" name="startDate" value={filters.startDate} onChange={handleFilterChange} />
              </Field>
              <Field label="Date To">
                <input type="date" className="prm-input" name="endDate" value={filters.endDate} onChange={handleFilterChange} />
              </Field>
              <Field label="Bus Type">
                <select className="prm-input prm-select" name="busType" value={filters.busType} onChange={handleFilterChange}>
                  <option value="">All Types</option>
                  <option value="AC">AC</option>
                  <option value="Non-AC">Non-AC</option>
                </select>
              </Field>
              <Field label="Bus Category">
                <select className="prm-input prm-select" name="busCategory" value={filters.busCategory} onChange={handleFilterChange}>
                  <option value="">All Categories</option>
                  <option value="sleeper">Sleeper</option>
                  <option value="seater">Seater</option>
                  <option value="semi-sleeper">Semi-Sleeper</option>
                </select>
              </Field>
              <Field label="Min Earnings">
                <input type="number" className="prm-input" name="minEarnings" value={filters.minEarnings} onChange={handleFilterChange} min="0" />
              </Field>
              <Field label="Max Earnings">
                <input type="number" className="prm-input" name="maxEarnings" value={filters.maxEarnings} onChange={handleFilterChange} min="0" />
              </Field>
            </div>
          </div>
          <div className="prm-form-foot">
            <span className="prm-foot-hint">{isFiltered ? 'Filters active' : 'No active filters'}</span>
            <div className="prm-form-foot-actions">
              <button className="prm-btn ghost" onClick={clearFilters}>Clear all</button>
              <button className="prm-btn primary" onClick={applyFilters}>Apply filters</button>
            </div>
          </div>
          {isFiltered && (
            <div className="cr-summary" style={{ marginTop: 12 }}>
              {searchTerm && <div><Icon name="search" size={14} /> <span>Search</span><b>{searchTerm}</b></div>}
              {filters.busType && <div><Icon name="bus" size={14} /> <span>Type</span><b>{filters.busType}</b></div>}
              {filters.busCategory && <div><Icon name="tag" size={14} /> <span>Category</span><b>{filters.busCategory}</b></div>}
              {filters.startDate && <div><Icon name="calendar" size={14} /> <span>From</span><b>{filters.startDate}</b></div>}
              {filters.endDate && <div><Icon name="calendar" size={14} /> <span>To</span><b>{filters.endDate}</b></div>}
              {filters.minEarnings && <div><Icon name="wallet" size={14} /> <span>Min</span><b>{filters.minEarnings}</b></div>}
              {filters.maxEarnings && <div><Icon name="wallet" size={14} /> <span>Max</span><b>{filters.maxEarnings}</b></div>}
            </div>
          )}
        </div>
      )}

      {/* LIST */}
      <div className={loading && profitData.length > 0 ? 'cr-loading' : ''}>
        {profitData.length === 0 && !loading ? (
          <div className="prm-empty">
            <div className="icon"><Icon name={searchTerm || isFiltered ? 'search' : 'wallet'} size={44} /></div>
            <h3>{searchTerm || isFiltered ? 'No profit data matches your filters' : 'No profit data yet'}</h3>
            <p>{searchTerm || isFiltered ? 'Try a different search or clear the filters.' : 'Profit data will appear here once bookings are recorded.'}</p>
            {(searchTerm || isFiltered) && (
              <button className="prm-btn ghost" onClick={handleRefresh}>Clear filters</button>
            )}
          </div>
        ) : layout === 'cards' ? (
          <div className="prm-grid">
            {profitData.map((item, i) => (
              <BusCard key={item.bus?.id || i} item={item} index={i} onView={handleViewBusDetails} loading={loading} />
            ))}
          </div>
        ) : (
          <div className="prm-table-wrap">
            <table className="prm-table">
              <thead>
                <tr>
                  <th onClick={() => handleSort('busNumber')} style={{ cursor: 'pointer' }}>Bus No. <SortArrow field="busNumber" /></th>
                  <th onClick={() => handleSort('busName')} style={{ cursor: 'pointer' }}>Bus Name <SortArrow field="busName" /></th>
                  <th>Type</th>
                  <th onClick={() => handleSort('ownerName')} style={{ cursor: 'pointer' }}>Owner <SortArrow field="ownerName" /></th>
                  <th onClick={() => handleSort('totalBookings')} style={{ cursor: 'pointer' }}>Bkgs <SortArrow field="totalBookings" /></th>
                  <th onClick={() => handleSort('totalSeatsSold')} style={{ cursor: 'pointer' }}>Seats <SortArrow field="totalSeatsSold" /></th>
                  <th onClick={() => handleSort('totalEarnings')} style={{ cursor: 'pointer' }}>Earnings <SortArrow field="totalEarnings" /></th>
                  <th onClick={() => handleSort('totalCommission')} style={{ cursor: 'pointer' }}>Commission <SortArrow field="totalCommission" /></th>
                  <th onClick={() => handleSort('netIncome')} style={{ cursor: 'pointer' }}>Net <SortArrow field="netIncome" /></th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {profitData.map((item, i) => (
                  <tr key={item.bus?.id || i} style={{ animationDelay: `${i * 50}ms` }}>
                    <td><b>{safeStr(item.bus?.busNumber) || 'N/A'}</b></td>
                    <td>{safeStr(item.bus?.busName) || 'N/A'}</td>
                    <td><BusTypePill value={item.bus?.busType} /></td>
                    <td>
                      <div className="pbo-cell-owner">
                        <Avatar name={item.owner?.name} size={38} />
                        <div>
                          <div className="name">{safeStr(item.owner?.name) || 'N/A'}</div>
                          <div className="sub">{safeStr(item.owner?.phone)}</div>
                        </div>
                      </div>
                    </td>
                    <td><span className="pbo-count">{safeNum(item.stats?.totalBookings)}</span></td>
                    <td><span className="pbo-count">{safeNum(item.stats?.totalSeatsSold)}</span></td>
                    <td style={{ color: '#0369a1', fontWeight: 600 }}>{formatCurrency(item.stats?.totalEarnings)}</td>
                    <td style={{ color: '#b45309', fontWeight: 600 }}>{formatCurrency(item.stats?.totalCommission)}</td>
                    <td style={{ color: '#2f855a', fontWeight: 600 }}>{formatCurrency(item.stats?.netIncome)}</td>
                    <td>
                      <div className="prm-row-actions">
                        <button className="prm-btn view sm icon-only" onClick={() => handleViewBusDetails(item)} disabled={loading} title="View" aria-label="View"><Icon name="eye" size={13} /></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* PAGINATION */}
      <Pagination
        page={currentPage} pageSize={pageSize} total={totalItems}
        onPage={(p) => setCurrentPage(Math.min(Math.max(1, p), totalPages))}
        onPageSize={(s) => { setPageSize(s); setCurrentPage(1); }}
        sizes={[10, 25, 50, 100]} label="buses"
      />

      {/* VIEW MODAL */}
      {viewingBus && (
        <div className="prm-overlay" onClick={closeViewModal}>
          <div className="prm-form-modal pbo-fleet" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="bus" size={22} /></span>
                <div>
                  <h3>{safeStr(viewingBus.bus?.busNumber) || 'Bus Details'}</h3>
                  <p>{safeStr(viewingBus.bus?.busName) || 'Profit breakdown'}</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={closeViewModal}>×</button>
            </div>

            <div className="prm-form-body">
              <div className="prm-section-title">Bus information</div>
              <div className="pbo-mini-stats">
                <div><span>Bus Number</span><b>{safeStr(viewingBus.bus?.busNumber) || 'N/A'}</b></div>
                <div><span>Bus Name</span><b>{safeStr(viewingBus.bus?.busName) || 'N/A'}</b></div>
                <div><span>Bus Type</span><b>{safeStr(viewingBus.bus?.busType) || 'N/A'}</b></div>
                <div><span>Total Seats</span><b>{safeNum(viewingBus.bus?.totalSeats)}</b></div>
              </div>

              <div className="prm-section-title">Owner information</div>
              <div className="pbo-mini-stats">
                <div><span>Owner</span><b>{safeStr(viewingBus.owner?.name) || 'N/A'}</b></div>
                <div><span>Company</span><b>{safeStr(viewingBus.owner?.companyName) || 'N/A'}</b></div>
                <div><span>Email</span><b>{safeStr(viewingBus.owner?.email) || 'N/A'}</b></div>
                <div><span>Phone</span><b>{safeStr(viewingBus.owner?.phone) || 'N/A'}</b></div>
                <div><span>Commission</span><b>{safeNum(viewingBus.owner?.commissionRate) || 10}%</b></div>
              </div>

              <div className="prm-section-title">Financial summary</div>
              <div className="cr-summary">
                <div><Icon name="wallet" size={16} /> <span>Earnings</span><b>{formatCurrency(viewingBus.summary?.totalEarnings)}</b></div>
                <div><Icon name="tag" size={16} /> <span>Commission</span><b>{formatCurrency(viewingBus.summary?.totalCommission)}</b></div>
                <div><Icon name="check" size={16} /> <span>Net Profit</span><b>{formatCurrency(viewingBus.summary?.netIncome)}</b></div>
                <div><Icon name="users" size={16} /> <span>Bookings</span><b>{safeNum(viewingBus.summary?.totalBookings)}</b></div>
                <div><Icon name="ticket" size={16} /> <span>Seats Sold</span><b>{safeNum(viewingBus.summary?.totalSeatsSold)}</b></div>
                <div><Icon name="info" size={16} /> <span>Occupancy</span><b>{safeNum(viewingBus.summary?.occupancyRate)}%</b></div>
              </div>

              {viewingBus.dailyBreakdown?.length > 0 && (
                <>
                  <div className="prm-section-title">Daily breakdown</div>
                  <div className="prm-table-wrap" style={{ maxHeight: 220, overflowY: 'auto' }}>
                    <table className="prm-table">
                      <thead>
                        <tr><th>Date</th><th>Earnings</th><th>Bookings</th><th>Seats Sold</th></tr>
                      </thead>
                      <tbody>
                        {viewingBus.dailyBreakdown.map((day, idx) => (
                          <tr key={idx}>
                            <td>{formatDateDMY(day.date)}</td>
                            <td>{formatCurrency(day.earnings)}</td>
                            <td>{safeNum(day.bookings)}</td>
                            <td>{safeNum(day.seatsSold)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}

              {viewingBus.bookings?.length > 0 && (
                <>
                  <div className="prm-section-title">Recent bookings</div>
                  <div className="prm-table-wrap" style={{ maxHeight: 220, overflowY: 'auto' }}>
                    <table className="prm-table">
                      <thead>
                        <tr><th>PNR</th><th>Date</th><th>Seats</th><th>Amount</th></tr>
                      </thead>
                      <tbody>
                        {viewingBus.bookings.slice(0, 5).map((b, idx) => (
                          <tr key={idx}>
                            <td className="transaction">{safeStr(b.pnr)}</td>
                            <td>{formatDateDMY(b.journeyDate)}</td>
                            <td>{safeNum(b.seatsBooked)}</td>
                            <td>{formatCurrency(b.amount)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {viewingBus.bookings.length > 5 && (
                    <p style={{ textAlign: 'center', marginTop: 10, color: '#718096', fontSize: 13 }}>
                      +{viewingBus.bookings.length - 5} more bookings
                    </p>
                  )}
                </>
              )}

              {isFetchingDetails && <div style={{ marginTop: 10, fontSize: 12, color: '#888' }}>Refreshing details…</div>}
            </div>

            <div className="prm-form-foot">
              <span />
              <div className="prm-form-foot-actions">
                <button className="prm-btn primary" onClick={closeViewModal}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfitReport;